export interface NormalizedPhone {
  primary: string;
  alternate: string;
}

/**
 * Normalize Israeli phone numbers to handle both +972 and 0 prefixes.
 * Returns both formats for flexible matching against the database.
 *
 * Examples:
 * "+972541234567" → { primary: "+972541234567", alternate: "0541234567" }
 * "0541234567" → { primary: "0541234567", alternate: "+972541234567" }
 */
export function normalizeIsraeliPhone(phone: string): NormalizedPhone {
  const cleaned = phone.replace(/\s/g, '');

  if (cleaned.startsWith('+972')) {
    return {
      primary: cleaned,
      alternate: '0' + cleaned.slice(3),
    };
  }

  if (cleaned.startsWith('0')) {
    return {
      primary: cleaned,
      alternate: '+972' + cleaned.slice(1),
    };
  }

  return {
    primary: cleaned,
    alternate: cleaned,
  };
}

/**
 * Build a wa.me deep link that opens a WhatsApp chat with this number.
 * wa.me needs digits only (no +, no leading 0) in international format.
 */
export function buildWhatsAppLink(phone: string): string {
  const { primary, alternate } = normalizeIsraeliPhone(phone);
  const international = primary.startsWith('+972') ? primary : alternate;
  const digits = international.replace(/\D/g, '');
  return `https://wa.me/${digits}`;
}
